document.addEventListener("DOMContentLoaded", function() {
  const slides = document.querySelectorAll(".slide");
  
  let currentSlide = 0;

  function showSlide(index, isNext = true) {
    slides[currentSlide].classList.remove("active");
    if (isNext) slides[currentSlide].classList.add("previous");
    slides[index].classList.add("active");
    slides[index].classList.remove("previous");
    currentSlide = index;
  }

  function nextSlide() {
    if (currentSlide + 1 >= slides.length) return;
    
    const nextIndex = (currentSlide + 1) % slides.length;
    showSlide(nextIndex);
  }

  function prevSlide() {
    if (currentSlide == 0) return;
    
    const prevIndex = (currentSlide + slides.length - 1) % slides.length;
    showSlide(prevIndex, false);
  }

  document.addEventListener("keydown", function(e) {
    if (e.key === "ArrowRight") {
      nextSlide();
    } else if (e.key === "ArrowLeft") {
      prevSlide();
    }
  });
  
  var touchStartX, touchEndX;

  document.addEventListener("touchstart", function(e) {
    touchStartX = e.changedTouches[0].clientX;
  });
  
  document.addEventListener("touchend", function(e) {
    touchEndX = e.changedTouches[0].clientX;
    if (touchEndX < touchStartX) {
      nextSlide();
    } else if (touchEndX > touchStartX) {
      prevSlide();
    }
  });

  var nextButtons = document.getElementsByClassName("slide__button--next")

  for (var i = 0; i < nextButtons.length; i++) {
    nextButtons[i].addEventListener('click', function() {
      // Your event handling code here
      console.log('Element clicked!');
      nextSlide();
    });
  }
});
